export { CellDirective } from './cell.directive';
